const sessionCache = {
  images: {},
};

export const imageCache = sessionCache.images;
export default sessionCache;
